import { render, staticRenderFns } from "./competition_level.vue?vue&type=template&id=4a843ad6&"
import script from "./competition_level.vue?vue&type=script&lang=js&"
export * from "./competition_level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports